import { useAudioStore } from '@store/index';
import { Field } from './Field';

export function AudioControls() {
  const volume = useAudioStore((s) => s.volume);
  const setVolume = useAudioStore((s) => s.setVolume);

  return (
    <>
      <Field label="Volume" value={`${Math.round(volume * 100)}%`}>
        <input
          type="range"
          min={0}
          max={1}
          step={0.01}
          value={volume}
          onChange={(e) => setVolume(Number(e.target.value))}
        />
      </Field>
    </>
  );
}
